import * as React from "react";
import { ShopifyNext } from "@dotdev/next-components";
import { GlobalProps } from "types";
import * as Snippets from "snippets";
import { trackPromotionClick } from "helpers";

export class MiniHero extends React.PureComponent<
  MiniHero.Props,
  MiniHero.State
> {
  public static contextType = ShopifyNext.Context;
  public static sectionId = "minihero";
  public componentDidMount = () => {
    // document.querySelector('.body-wrapper').classList.remove('pt-5-6', 'pt-9-6', 'md:pt-11-3')
  };

  public render(): JSX.Element {
    const { settings, blocks } = this.props.section;
    const contentClasses: string[] = [];
    const { image } = settings;
    const mobileImage = settings.imagemobile
      ? settings.imagemobile
      : settings.image;
    settings && settings.color
      ? contentClasses.push(
          settings.color === "black" ? "text-black" : "text-white"
        )
      : null;

      // get desktop and mobile link url from the blocks
      const desktopLinkBlock = blocks.find((block: any) => block.type === "link");
      const mobileLinkBlock = blocks.find((block: any) => block.type === "linkmobile");

      const desktopLinkURL = desktopLinkBlock?.settings?.linkurl;
      const mobileLinkURL = mobileLinkBlock?.settings?.linkurl;

      const contentPosition = settings.content_position;

      console.log("desktopLinkURL", desktopLinkURL);
      console.log("mobileLinkURL", mobileLinkURL);
      

    return (
      <div>
        <section className={"dynamic-minihero"}>
          <div className={"relative mx-auto"}>
            {desktopLinkURL ? (
              <a href={desktopLinkURL}>
                <Snippets.Image
                  alt={settings.title || "Hero banner image"}
                  ratio={"21:9"}
                  className={"absolute inset-0 hidden lg:block"}
                  src={image}
                  preventLazy
                />
              </a>
            ) : (
              <Snippets.Image
                alt={settings.title || "Hero banner image"}
                ratio={"21:9"}
                className={"absolute inset-0 hidden lg:block"}
                src={image}
                preventLazy
              />
            )}
            {mobileLinkURL ? (
              <a href={mobileLinkURL}>
                <Snippets.Image
                  alt={settings.title || "Hero banner mobile image"}
                  ratio={"3:2"}
                  className={"absolute inset-0 block lg:hidden max-h-144"}
                  src={mobileImage}
                  preventLazy
                />
              </a>
            ) : (
              <Snippets.Image
                alt={settings.title || "Hero banner mobile image"}
                ratio={"3:2"}
                className={"absolute inset-0 block lg:hidden max-h-144"}
                src={mobileImage}
                preventLazy
              />
            )}
            {settings.title || settings.content || settings.note || blocks ? (
              <div
                className={`absolute flex justify-center ${
                  settings.content_position == "top" ? "items-start top-0 left-0 right-0" : null
                } ${
                  settings.content_position == "middle" ? "items-center inset-0" : null
                } ${
                  settings.content_position == "bottom" ? "items-end bottom-0 left-0 right-0" : null
                } z-10 mx-auto w-full max-w-6xl px-1-6 md:px-3-2 py-2 md:py-4 ${contentClasses.join(
                  " "
                )}`}
              >
                <div className={"w-full md:w-full text-center"}>
                  {settings.title && (
                    <Snippets.Heading
                      size={"h1"}
                      tag={"h2"}
                      className={"mb-1-6 md:text-5xl font-bold"}
                    >
                      {settings.title}
                    </Snippets.Heading>
                  )}

                  {settings.content && (
                    <Snippets.RichText size={4} className={"mb-2"}>
                      {settings.content}
                    </Snippets.RichText>
                  )}

                  {blocks && (
                    <div
                      className={"flex flex-wrap justify-center items-center"}
                    >
                      {blocks.map((block: any, i: number) =>
                        this.buildPromotionLinks(
                          block,
                          i,
                          settings.color,
                          settings.cta_style
                        )
                      )}
                    </div>
                  )}

                  {settings.note && (
                    <Snippets.RichText size={6} className={"mt-3-2"}>
                      {settings.note}
                    </Snippets.RichText>
                  )}
                </div>
              </div>
            ) : null}
          </div>
        </section>
      </div>
    );
  }

  private buildPromotionLinks = (
    item: any,
    i: number,
    color,
    cta_style
  ): JSX.Element => {
    const { settings } = item;
    const underlineClassName =
      "mt-1-3 md:mt-1-8 flex items-center underline cursor-pointer uppercase";
    const boxClassName =
      "bg-black text-white border border-black text-center px-1-6 font-bold text-xs md:mt-3 mx-0-3 pt-1-1 pb-1 hover:bg-white hover:text-black uppercase cursor-pointer";

    return (
      <div
        key={i}
        className={`w-1/2 md:w-1/4 group ${
          item.type == "link" ? "hidden md:block" : "md:hidden"
        }`}
      >
        <div className={"relative"}>
          {settings.linkurl && settings.linktext ? (
            <div
              className={`flex items-center justify-center z-10 w-full
              ${color == "black" ? "text-black" : "text-white"}`}
            >
              <div className={"flex flex-col items-center justify-center px-1"}>
                {settings.linktext ? (
                  <Snippets.Button
                    onClick={() =>
                      trackPromotionClick(
                        [
                          {
                            id: `${this.props.section.id}-block-${i}`,
                            name: settings.title,
                            creative: "Mini hero",
                            position: `${i}`,
                          },
                        ],
                        settings.linkurl
                      )
                    }
                    colour={`${
                      cta_style === "black" || cta_style == "box"
                        ? "primary"
                        : cta_style === "white"
                        ? "secondary"
                        : cta_style === "transparent"
                        ? "secondary-transparent"
                        : cta_style == "underline"
                        ? "underline"
                        : "secondary-transparent-reverse"
                    }`}
                    target={settings.linkurl}
                    title={settings.linktext}
                  >
                    {settings.linktext}
                  </Snippets.Button>
                ) : null}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  };
}

export namespace MiniHero {
  export interface Options
    extends ShopifyNext.Section<{
      image?: string;
      imagemobile?: string;
      title?: string;
      content?: string;
      note?: string;
      color?: string;
      cta_style?: string;
      content_position?: string;
    }> {
    block_size: number;
  }
  export interface Props extends GlobalProps {
    section: MiniHero.Options;
  }
  export interface State {}
}
